import Emitter from "es6-event-emitter";
import APIManager from "./../../../common/utilities/apimanager";

import { createDivWithClass } from "./../../../common/utilities/utils";

import { TOPNAV_BUTTON } from "./../../../common/utilities/redirectorKeys";

export default class TopNavButtonComponent extends Emitter {
  appState = null;
  DOMContainer = null;
  DOMContent = null;
  options = null;
  constructor(appState, DOMContainer, options, isCookieConsentButton = false) {
    super();
    this.appState = appState;
    this.DOMContainer = DOMContainer;
    this.options = options;
    this.isCookieConsentButton = isCookieConsentButton; //any object whose function needs to be called when the topNavButton is clicked.
    this.render();
    this.attachListeners();
  }

  attachListeners() {
    this.appState.on("appState:authenticationstatuschanged", () => {
      this.onAuthenticationStatusChanged();
    });
  }

  retrieveUrl() {
    const promise = new Promise((resolve) => {
      if (this.appState.isDesktop) {
        APIManager.getRedirectorUrl(
          TOPNAV_BUTTON,
          this.appState.buildVersion,
          this.appState.userId,
          this.appState.downloadToken
        )
          .then((url) => {
            //TODO: fill in parameters
            this.url = url;
            resolve(this.url);
          })
          .catch(() => {
            this.url = null;
          });
      }
    });
    return promise;
  }

  render() {
    const topNavButton = createDivWithClass("top-nav_button");
    if (this.options && this.options.topNavButtonHasFunction) {
      this.createButton(topNavButton);
      topNavButton.addEventListener("click", () => {
        this.appState.analyticsManager.cmpManager.showPreference();
      });
    } else {
      this.retrieveUrl().then(() => {
        if (this.url && this.url != "") {
          this.createButton(topNavButton);
          topNavButton.addEventListener("click", () => {
            window.open(this.url, "_blank");
          });
        }
      });
    }
  }

  createButton(topNavButton) {
    if (this.options && this.options.topNavButtonLabel) {
      topNavButton.innerHTML = this.options.topNavButtonLabel;
      topNavButton.classList.add("pointer");
    }
    if (
      this.options &&
      this.options.toggleSubscriptionTopNavButtonOnUserLoggedIn &&
      this.appState.isLoggedIn
    ) {
      topNavButton.classList.add("hidden");
    }
    this.DOMContainer.appendChild(topNavButton);
  }

  onAuthenticationStatusChanged() {
    const topNavButton = this.DOMContainer.querySelector(".top-nav_button");
    if (this.appState.isLoggedIn) {
      if (
        this.options &&
        this.options.toggleSubscriptionTopNavButtonOnUserLoggedIn &&
        topNavButton
      ) {
        topNavButton.classList.add("hidden");
      }
    } else {
      if (
        this.options &&
        this.options.toggleSubscriptionTopNavButtonOnUserLoggedIn &&
        topNavButton
      ) {
        topNavButton.classList.remove("hidden");
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/web/home/components/topNavButtonComponent.js